function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend } from 'chart.js';
import { Button, Table } from 'antd';
import SalesPeriodFilter from './filter/line-chart-filter';
import { formatCurrency } from '../../utils/format-data';
import dayjs from 'dayjs';
ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend);
const normalizeChartData = (items, periodMode) => {
    if (periodMode === 'year') {
        const filled = Array.from({
            length: 12
        }, (_, i) => {
            var _a, _b, _c;
            const month = i + 1;
            const found = items.find(x => x.month === month);
            return {
                month,
                total_sales: (_a = found === null || found === void 0 ? void 0 : found.total_sales) !== null && _a !== void 0 ? _a : 0,
                subscription_sales: (_b = found === null || found === void 0 ? void 0 : found.subscription_sales) !== null && _b !== void 0 ? _b : 0,
                like_sales: (_c = found === null || found === void 0 ? void 0 : found.like_sales) !== null && _c !== void 0 ? _c : 0
            };
        });
        return {
            data: filled,
            labels: filled.map(i => `${i.month}月`),
            values: filled.map(i => i.total_sales)
        };
    }
    return {
        data: items,
        labels: items.map(i => {
            const d = new Date(i.day);
            return `${d.getDate()}`;
        }),
        values: items.map(i => i.total_sales)
    };
};
export function LineChartSale({ items, params, onChange }) {
    const _useState = useState('chart'), _useState2 = _slicedToArray(_useState, 2), viewMode = _useState2[0], setViewMode = _useState2[1];
    const _useState3 = useState([]), _useState4 = _slicedToArray(_useState3, 2), data = _useState4[0], setData = _useState4[1];
    const _useState5 = useState([]), _useState6 = _slicedToArray(_useState5, 2), labels = _useState6[0], setLabels = _useState6[1];
    const _useState7 = useState([]), _useState8 = _slicedToArray(_useState7, 2), values = _useState8[0], setValues = _useState8[1];
    const chartData = {
        labels,
        datasets: [{
                data: values,
                borderColor: '#1F7A4D',
                borderWidth: 2.5,
                tension: 0,
                pointRadius: 0,
                pointHoverRadius: 5,
                hitRadius: 14,
                hoverRadius: 6
            }]
    };
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: 'nearest',
            intersect: false,
            axis: 'x'
        },
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                displayColors: false,
                backgroundColor: '#2A2A2A',
                padding: 10,
                cornerRadius: 4,
                callbacks: {
                    title: items => {
                        const item = data[items[0].dataIndex];
                        if (!item)
                            return '';
                        if (params.mode === 'year') {
                            return `${item.month}月`;
                        }
                        if (params.mode === 'month' && item.day) {
                            const d = new Date(item.day);
                            return `${d.getMonth() + 1}月${d.getDate()}日`;
                        }
                        return '';
                    },
                    label: ctx => `売上 ${formatCurrency({
                        value: Number(ctx.raw)
                    })}`
                }
            }
        },
        scales: {
            x: {
                grid: {
                    display: false
                },
                ticks: {
                    color: '#666',
                    font: {
                        size: 11
                    },
                    autoSkip: true
                }
            },
            y: {
                grid: {
                    color: '#EEEEEE'
                },
                ticks: {
                    color: '#666',
                    font: {
                        size: 11
                    },
                    callback: v => Number(v).toLocaleString('ja-JP')
                }
            }
        }
    };
    useEffect(() => {
        if (!(items === null || items === void 0 ? void 0 : items.length))
            return;
        if (!params.mode)
            return;
        const normalized = normalizeChartData(items, params.mode);
        setData(normalized.data);
        setLabels(normalized.labels);
        setValues(normalized.values);
    }, [items, params.mode]);
    const columns = React.useMemo(() => {
        if (params.mode === 'year') {
            return [{
                    title: '月',
                    dataIndex: 'month',
                    key: 'month',
                    render: v => `${v}月`
                }, {
                    title: 'サブスク売上',
                    dataIndex: 'subscription_sales',
                    render: v => formatCurrency({
                        value: v
                    })
                }, {
                    title: 'いいね売上',
                    dataIndex: 'like_sales',
                    render: v => formatCurrency({
                        value: v
                    })
                }, {
                    title: '合計',
                    dataIndex: 'total_sales',
                    render: v => formatCurrency({
                        value: v
                    })
                }];
        }
        return [{
                title: '日',
                dataIndex: 'day',
                key: 'day',
                render: v => dayjs(v).format('D日')
            }, {
                title: 'サブスク売上',
                dataIndex: 'subscription_sales',
                render: v => formatCurrency({
                    value: v
                })
            }, {
                title: 'いいね売上',
                dataIndex: 'like_sales',
                render: v => formatCurrency({
                    value: v
                })
            }, {
                title: '合計',
                dataIndex: 'total_sales',
                render: v => formatCurrency({
                    value: v
                })
            }];
    }, [params.mode]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-between"
    }, /*#__PURE__*/ React.createElement(SalesPeriodFilter, {
        onChange: onChange
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-2"
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: () => setViewMode('chart'),
        className: viewMode === 'chart' ? '!bg-[#f0c52a36]' : ''
    }, "\u30B0\u30E9\u30D5"), /*#__PURE__*/ React.createElement(Button, {
        onClick: () => setViewMode('table'),
        className: viewMode === 'table' ? '!bg-[#f0c52a36]' : ''
    }, "\u8868"))), /*#__PURE__*/ React.createElement("div", {
        style: {
            height: 400
        },
        className: "max-w-content"
    }, viewMode === 'chart' ? /*#__PURE__*/ React.createElement(Line, {
        data: chartData,
        options: chartOptions
    }) : /*#__PURE__*/ React.createElement(Table, {
        key: params.mode,
        rowKey: (__, index) => `row-${index}`,
        dataSource: data,
        columns: columns,
        pagination: false,
        locale: {
            emptyText: 'データがありません'
        },
        scroll: {
            y: 380
        }
    })));
}
